/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_PhoneInputs */

const en_contact_channel_phone = /** @type {(inputs: Contact_Channel_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const lv_contact_channel_phone = /** @type {(inputs: Contact_Channel_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tālrunis`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Contact_Channel_PhoneInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_phone = /** @type {((inputs?: Contact_Channel_PhoneInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_PhoneInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_phone(inputs)
	return en_contact_channel_phone(inputs)
});